export default __webpack_public_path__ + "static/media/avalancheLogo.806059c9.png";